import { AccountBalanceOutlined, Link } from '@mui/icons-material';
import { Button, styled } from '@mui/material';
import Typography from '@mui/material/Typography';
import { Card, CardContent } from 'further-ui/components/Card';
import FurtherLogoIcon from 'further-ui/components/FurtherLogoIcon';
import { Column, Row } from 'further-ui/components/Layout';
import TypographyButton from 'further-ui/components/TypographyButton';

const Wrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
});

const StyledColumn = styled(Column)({
  maxWidth: 390,
});

const IconCardContent = styled(CardContent)({
  display: 'flex',
});

type Props = {
  onConnectBankAccount?: () => void;
  onUploadManually?: () => void;
};

const NoAccounts: React.FC<Props> = ({
  onConnectBankAccount,
  onUploadManually,
}) => {
  return (
    <Wrapper>
      <StyledColumn spacing="lg" centered>
        <Row spacing="sm" centered>
          <Card variant="outlined">
            <IconCardContent size="xs">
              <FurtherLogoIcon color="primary" fontSize="medium" />
            </IconCardContent>
          </Card>
          <Link fontSize="medium" />
          <Card variant="outlined">
            <IconCardContent size="xs">
              <AccountBalanceOutlined fontSize="medium" />
            </IconCardContent>
          </Card>
        </Row>
        <Column fullWidth spacing="xs">
          <Typography variant="h4" textAlign="center">
            Connect your bank account
          </Typography>
          <Typography textAlign="center" variant="body2">
            Match bank transactions to what’s recorded in Further to keep cash
            balances accurate. Connect a bank account (recommended) or upload
            statements manually.
          </Typography>
        </Column>
        {onConnectBankAccount ? (
          <Button
            variant="contained"
            size="large"
            onClick={onConnectBankAccount}
          >
            Connect bank account
          </Button>
        ) : null}
        {onUploadManually ? (
          <Typography variant="body2">
            <TypographyButton
              text="Upload statements manually"
              onClick={onUploadManually}
            />
          </Typography>
        ) : null}
      </StyledColumn>
    </Wrapper>
  );
};

export default NoAccounts;
